import { AboutFour } from "../../components/About/AboutFour";
import { BannerThree } from "../../components/Banners/BannerThree";
import { FeatureThree } from "../../components/Features/FeatureThree";
import { PricingAreaOne } from "../../components/PricingAreas/PricingAreaOne";
import SupportingVision from "../../components/SupportingVision";
import { Layout } from "../../layouts/Layout";

const HomeTwo = () => {
  return (
    // header={3} footer={3}
    <Layout>
      <BannerThree />

      <FeatureThree />

      <AboutFour />

      <PricingAreaOne />

      <SupportingVision />
    </Layout>
  );
};

export default HomeTwo;
